import React from 'react';
import { ASSETS } from '../mock';
import { Heart } from 'lucide-react';

const JoinNow = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <section className="relative bg-fnl-dark py-20 px-6 md:px-12 overflow-hidden">
      {/* Gradient backgrounds */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-fnl-pink/30 to-transparent" />
      <div className="absolute bottom-0 right-0 w-1/3 h-full bg-gradient-to-tl from-purple-700/40 to-transparent" />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 items-center bg-fnl-purple/40 backdrop-blur-sm rounded-3xl p-10 md:p-14 border border-purple-900/40 overflow-hidden">
          {/* Left content */}
          <div className="relative z-10">
            <div className="flex items-center gap-2 mb-3">
              <Heart className="w-5 h-5 fill-fnl-pink text-fnl-pink animate-pulse-soft" />
              <span className="text-fnl-pink uppercase tracking-wider text-sm font-semibold">Join Now</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              Join Now <span className="text-fnl-pink">it's 100% free</span>
            </h2>
            <p className="text-purple-200 text-lg mb-7">
              Discover real connections. Meet, chat, and flirt with locals tonight.
            </p>
            <button
              onClick={scrollTop}
              className="px-8 h-14 bg-fnl-pink hover:bg-fnl-pink text-white font-semibold rounded-full btn-shadow-pink text-base"
            >
              Get Started Now
            </button>
          </div>

          {/* Right image */}
          <div className="relative h-[320px] md:h-[420px]">
            <img
              src={ASSETS.joinWoman}
              alt="Join now"
              className="absolute right-0 bottom-0 h-full object-contain z-10"
            />
            <img
              src={ASSETS.mediumHeart}
              alt=""
              className="absolute top-6 right-12 w-12 h-12 animate-float"
            />
            <img
              src={ASSETS.smallIconHeart}
              alt=""
              className="absolute bottom-16 right-44 w-8 h-8 animate-float-slow"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinNow;
